export default "__VITE_ASSET__BGj5TE88__";